export const homeFaqItems = [
  {
    question: "What is Tawde.in Vadhu Var Search?",
    answer:
      "Tawde.in Vadhu Var Search is online brand of 'Marathi Vadhu Var Suchak', which display educated Kokanastha Vadhu Var list on one click. It's simply free classified of 'Marathi Vadhu Var Suchak'.",
  },
  {
    question: "What are the benefits of Tawde.in Vadhu Var Search?",
    answer:
      "Educated Kokanastha Vadhu Var can search and view profiles on just single click with photo.",
  },
  {
    question: "How could I add my profile on Tawde.in Vadhu Var Search list?",
    answer:
      "It's very easy, just register free on parent site 'MarathiVadhuVarSuchak.com'. And your profile will be display on Tawde.in list too.",
  },
  {
    question:
      "How could I see full profile viewed on Tawde.in Vadhu Var search?",
    answer:
      "First register free on parent site 'MarathiVadhuVarSuchak.com' and then you can see full profile, which was viewed on Tawde.in Vadhu Var search result.",
  },
  {
    question: "Can I use Tawde.in Vadhu Var search for free?",
    answer:
      "Yes! Tawde.in Vadhu Var search is free. However, it's parent site 'MarathiVadhuVarSuchak.com' also allowed free registration.",
  },
] as const;
